import { ADD_MODEL, DELETE_MODEL, GET_MODELS, UPDATE_MODEL } from "../types";

const initialState = {list: [], single: null, cities: []};

const reducer = (state = initialState, action) => {
    const {type, payload} = action;

    switch (type) {
        case GET_MODELS:
            return {...state, list: payload};

        case UPDATE_MODEL:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload._id ? payload : item
                ),
            };

        case ADD_MODEL:
            return {
                ...state,
                list: [payload, ...state.list],
            };

        case DELETE_MODEL:
            return {
                ...state,
                list: state.list.filter((item) => item.id !== payload.id),
            };

        default:
            return state;
    }
};

export default reducer;
